import React from 'react'

import { makeStyles } from '@material-ui/core/styles'


//Material UI
import Button from '@material-ui/core/Button'
import CardActions from '@material-ui/core/CardActions'
import SaveIcon from '@material-ui/icons/Save'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'

export const useStyles = makeStyles((theme) => ({
  text: {
    [theme.breakpoints.down('500')]: {
      display: 'none'
    }
  },
  button : {
    [theme.breakpoints.down('500')]: {
      '& .MuiButton-iconSizeMedium' : {
        marginLeft: 0,
        marginRight: 0
      }
    }
  }  
}))

function TabNavigation(props) {
  const classes = useStyles()

  const { save, previous, next, disabled=false } = props

  return (
    <CardActions style={{ position: 'relative' }}>
      <div>

        {save &&
          <Button
            variant="contained"
            color="primary"
            disableElevation
            type="submit"
            disabled={disabled}
            startIcon={<SaveIcon />}
            className={classes.button}
          ><span className={classes.text}>Enregistrer</span></Button>
        }

        <div style={{ position: 'absolute', right: 16, top: 16 }} >
          {previous &&
            <Button
              variant="contained"
              color="primary"
              disableElevation
              startIcon={<NavigateBeforeIcon />}
              style={{ marginRight: 8 }}
              type="submit"
              disabled={disabled}
              data-action="previous"
              className={classes.button}
            ><span className={classes.text}>Précédent</span></Button>
          }

          {next &&
            <Button
              variant="contained"
              color="primary"
              disableElevation
              type="submit"
              disabled={disabled}
              endIcon={<NavigateNextIcon />}
              data-action="next"
              className={classes.button}
            ><span className={classes.text}>Suivant</span></Button>
          }

        </div>
      </div>
    </CardActions>
  )
}

export default TabNavigation
